import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "input", "submit", "trigger"]
  static values = { expected: String }

  toggle() {
    this.panelTarget.classList.toggle("hidden")
    this.triggerTarget.classList.toggle("hidden")
    if (!this.panelTarget.classList.contains("hidden")) {
      this.inputTarget.focus()
    }
  }

  validate() {
    const matches = this.inputTarget.value === this.expectedValue
    this.submitTarget.disabled = !matches
    this.submitTarget.classList.toggle("bg-red-400", !matches)
    this.submitTarget.classList.toggle("cursor-not-allowed", !matches)
    this.submitTarget.classList.toggle("bg-red-600", matches)
    this.submitTarget.classList.toggle("hover:bg-red-700", matches)
    this.submitTarget.classList.toggle("cursor-pointer", matches)
  }
}
